import { Injector, Pipe, PipeTransform } from '@angular/core';
import { FormElementRegistry, ViewRuleRegistry, Farris, FrameContext } from '@farris/devkit';
import { AttachmentCommonPipe } from './attachment_common.pipe';

@Pipe({ name: 'attachmentNoPreview' })
export class AttachmentNoPreviewPipe extends AttachmentCommonPipe implements PipeTransform {
  
  constructor(protected injector: Injector, protected formElementRegistry: FormElementRegistry,
    protected viewRuleRegistry: ViewRuleRegistry, protected frameContext: FrameContext) {
      super(formElementRegistry, viewRuleRegistry, Farris.FormRule.RuleType.NoPreview);
  }
}
